module.exports = __webpack_public_path__ + "static/img/code.5541812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/code.png
// module id = 8ZKg
// module chunks = 0